export default __webpack_public_path__ + "static/usa_west_virginia_cash_25-4fcb03c8cc2e5e78701172f2c7611606.png";